
import { defineComponent } from "vue";

export default defineComponent({
  name: "BotaoVue",
  emits: ['clicado'],
  props: {
    desabilitado: {
      type: Boolean
    },
    color: {
      type: String,
      required: true,
    },
    icone: {
      type: String,
      required: true
    },
    loading: {
      type: Boolean
    },
    texto: {
      type: String,
      required: true
    },
  },
  methods: {
    clicado () : void {
      this.$emit('clicado')
    }
  }
});
